import {
  Alert,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FormEvent, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import HolaVidaLogo from "src/assets/icons/HolaVidaLogo";
import { theme } from "src/assets/theme";
import LoadingButton from "src/components/Buttons/LoadingButton";
import { supabaseClient } from "src/supabase/supabaseClient";

const ResetPassword = () => {
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [displayAlert, setDisplayAlert] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleResetLink = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setLoading(true);

      try {
        const { error } = await supabaseClient.auth.resetPasswordForEmail(
          email,
          {
            redirectTo: `${import.meta.env.VITE_BASE_URL}/update-password`,
          },
        );

        if (error == null) {
          setDisplayAlert(true);
          setEmail("");
          setDisableButton(true);
        }
      } catch (err) {
        console.error("Unexpected error", err);
      } finally {
        setLoading(false);
      }
    },
    [email],
  );

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100%"
      padding="1rem"
    >
      <Stack gap="3rem">
        <Box
          component="form"
          role="form"
          onSubmit={handleResetLink}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "max-contnet",
            maxWidth: "380px",
            width: "100%",
            boxShadow: 10,
            p: 5.5,
            borderRadius: "12px",
            backgroundColor: "#ffffff",
          }}
        >
          <Box sx={{ alignSelf: "center" }}>
            <HolaVidaLogo width={180} height={90} />
          </Box>
          <Stack sx={{ mt: 1 }} gap={3}>
            <Typography variant={"h5"} fontWeight={700} width={"400px"}>
              Reset Password
            </Typography>
            <Stack gap={4}>
              <TextField
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                id="filled-adornment-email"
                label="Email"
              />
              <Stack gap={2}>
                <LoadingButton
                  loading={loading}
                  type="submit"
                  disabled={disableButton}
                >
                  Send Reset Link
                </LoadingButton>
                <Button
                  variant="alternate"
                  sx={{ backgroundColor: theme.palette.grey[300] }}
                  onClick={() => navigate(-1)}
                >
                  Back
                </Button>
              </Stack>
              {displayAlert ? (
                <Alert severity="success">
                  If this email is registered, a password reset link has been
                  sent to your inbox.
                </Alert>
              ) : null}
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
};

export default ResetPassword;
